import { WxIcon, type WxIconProps } from '../icons/WxIcon'
import { memo } from 'react'

/** Inline contours keep the first-paint DOM small; no dormant 188-symbol sprite is mounted. */
export const WeatherGlyph = memo(function WeatherGlyph({ condition, night = false, size = 24, ...props }: Omit<WxIconProps, 'sprite'>) {
  return <WxIcon condition={condition} night={night} size={size} label={null} {...props} />
})
